import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HttpJsonHeader } from "../../features/Environments";
import { setReminder } from "../../features/UserActions";
import { Link } from "react-router-dom";
import { ConvertDateFromSQL, DateAddMinutes } from "../../core/ThaiDate";
import { BiMessage, BiTrash } from "react-icons/bi";
import { Button } from "react-bootstrap";
import {
  EnumMessageFor,
  EnumReplyButtonStyle,
  EnumStudyID,
  GetEnumValue,
} from "../../core/Helper";
import { NotifyMessageService } from "../../model/notify-message";
import { Oval } from "react-loading-icons";
import { StudyService } from "../../model/study";

export default function Notification(props) {
  const userDetail = useSelector((state) => state.user);
  // const [messages, setMessages] = useState([]);
  const [messages, setMessages] = props.messages;
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = props.deleting;
  const [showBar, setShowBar] = props.messageBar;

  const dispatch = useDispatch();

  useEffect(() => {
    loadMessages();
    return () => {
      setMessages([]);
    };
  }, []);

  const loadMessages = async () => {
    setLoading(true);
    let res = await NotifyMessageService.GetUserMessage({
      UserInfo: userDetail,
    });
    if (res) {
      //console.log(res);
      setMessages(JSON.parse(res?.data));
    }
    setLoading(false);
  };

  const removeMessage = async (row) => {
    setDeleting(true);
    let res = await NotifyMessageService.RemoveUserMessage({
      UserInfo: userDetail,
      MessageId: row.StudyMessageId,
    });

    if (res) {
      setMessages(JSON.parse(res?.data));
    }
    setDeleting(false);
  };

  // check event at 'RadioWorklist'
  const openStudyForRadiologist = (pacsStudyId, messageId) => {
    document.dispatchEvent(
      new CustomEvent("openStudyFromNotifyBox", {
        detail: { studyId: pacsStudyId, messageId: messageId },
      })
    );

    setShowBar(false);
  };

  // check event at 'TechWorklist'
  const openResultForAdmin = (pacsStudyId, messageId) => {
    document.dispatchEvent(
      new CustomEvent("openResultFromNotifyBox", {
        detail: { studyId: pacsStudyId, messageId: messageId },
      })
    );
  };

  // Dispaly Reply Button style
  const replyButtonStyle = (row) => {
    //console.log(row?.Study);
    switch (row.Action.ReplyButtonStyle) {
      case EnumReplyButtonStyle.RADI_CONFIRM_STUDY:
        return (
          <div style={messageButtonContainer}>
            <div>
              <Link
                to="/rdoworklist"
                onClick={() => {
                  openStudyForRadiologist(row.Study.PacsStudyId, -1);
                }}
              >
                <Button variant="primary" style={messageButton}>
                  อ่านผล
                </Button>
              </Link>

              {row?.Study?.IsRadiAccepted === false ? (
                <Button
                  variant="success"
                  style={messageButton}
                  onClick={() => radiAcceptCase(row, row?.StudyMessageId)}
                >
                  รับเคส
                </Button>
              ) : (
                <></>
              )}

              {row?.Study?.IsRadiAccepted === false ? (
                <Button
                  variant="danger"
                  style={messageButton}
                  onClick={() => radiRejectCase(row, row?.StudyMessageId)}
                >
                  ปฏิเสธ
                </Button>
              ) : (
                <></>
              )}
            </div>
            <Button
              variant="danger"
              style={messageButton}
              onClick={() => removeMessage(row)}
            >
              <BiTrash />
            </Button>
          </div>
        );
      case EnumReplyButtonStyle.ADMIN_ACCEPTED_RESULT:
        return (
          <div style={messageButtonContainer}>
            <div>
              <Button
                variant="primary"
                style={messageButton}
                onClick={() => openResultForAdmin(row.Study.PacsStudyId, -1)}
              >
                รับทราบและเปิดผล
              </Button>
            </div>
            <Button
              variant="danger"
              style={messageButton}
              onClick={() => removeMessage(row)}
            >
              <BiTrash />
            </Button>
          </div>
        );
      default:
        return (
          <div style={messageButtonContainer}>
            <div>
              {/* <Button variant="primary" style={messageButton}>
                รับทราบและเปิดผล
              </Button> */}
            </div>
            <Button
              variant="danger"
              style={messageButton}
              onClick={() => removeMessage(row)}
            >
              <BiTrash />
            </Button>
          </div>
        );
    }
  };

  const CreateLabelInfo = (label, data) => {
    return (
      <div>
        <span style={spanLabel}>{label}: </span>
        <span>{data}</span>
      </div>
    );
  };

  //** Radiologist reject a case */
  const radiRejectCase = async (row, messageId) => {
    let res = await StudyService.UpdateStudyStatus({
      StudyInfo: row,
      StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_REJECTED),
      MessageId: messageId,
      UserInfo: userDetail,
    });
    if (res) {
      dispatch(
        setReminder({
          show: true,
          message: "ปฏิเสธเคสแล้ว",
          type: "success",
        })
      );
      removeMessage(row);
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถปฏิเคสได้",
          type: "error",
        })
      );
    }
    setShowBar(false);
    // axios
    //   .post(
    //     process.env.REACT_APP_API + "api/studyinfo/update-study-status",
    //     {
    //       StudyInfo: row,
    //       StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_REJECTED),
    //       MessageId: messageId,
    //       UserInfo: userDetail,
    //     },
    //     HttpJsonHeader
    //   )
    //   .then((res) => {
    //     dispatch(
    //       setReminder({
    //         show: true,
    //         message: "ปฏิเสธเคสแล้ว",
    //         type: "success",
    //       })
    //     );
    //     removeMessage(row);
    //     setShowBar(false);
    //   })
    //   .catch((err) => {
    //     // dispatch(
    //     //   setReminder({ show: true, message: err.message, type: "error" })
    //     // );
    //   });
  };

  const radiAcceptCase = async (row, messageId) => {
    let res = await StudyService.UpdateStudyStatus({
      StudyInfo: row,
      StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_ACCEPTED),
      MessageId: messageId,
      UserInfo: userDetail,
    });
    if (res) {
      dispatch(
        setReminder({
          show: true,
          message: "รับเคสแล้ว",
          type: "success",
        })
      );
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "การดำเนินการมีข้อผิดพลาด",
          type: "error",
        })
      );
    }
    setShowBar(false);

    // axios
    //   .post(
    //     process.env.REACT_APP_API + "api/studyinfo/update-study-status",
    //     {
    //       StudyInfo: row,
    //       StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_ACCEPTED),
    //       MessageId: messageId,
    //       UserInfo: userDetail,
    //     },
    //     HttpJsonHeader
    //   )
    //   .then((res) => {
    //     dispatch(
    //       setReminder({
    //         show: true,
    //         message: "รับเคสแล้ว",
    //         type: "success",
    //       })
    //     );
    //     // removeMessage(row);
    //     setShowBar(false);
    //   })
    //   .catch((err) => {
    //     if (err?.response?.data?.result === false) {
    //       dispatch(
    //         setReminder({
    //           show: true,
    //           message: "ไม่สามารถดำเนินการได้",
    //           type: "error",
    //         })
    //       );
    //     }
    //   });
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            color: "#660099",
          }}
        >
          <Oval height={150} width={150} speed={4} />
          <p>Loading..</p>
        </div>
      ) : (
        <div>
          {messages.map((row, index) => {
            return (
              <div style={messageBoxContainer}>
                {/* Header ข้อความสถานะ + เวลา */}
                <div style={messageBodyHeader}>
                  <span style={{ fontSize: "16px" }}>
                    <BiMessage
                      key={index}
                      style={{ marginRight: "3px", color: "#0000ff" }}
                    />
                    {row.Action.MessageFor === EnumMessageFor.RADIOLOGIST
                      ? row.Action.RadiMessage
                      : row.Action.AdminMessage}
                  </span>
                  <span style={{ fontSize: "12px", color: "#0e3a92" }}>
                    {ConvertDateFromSQL(row.Created)}
                  </span>
                </div>

                {/* โรงพยาบาล */}

                <div style={messageBodyHospital}>
                  {row.Study?.Customer?.CustShortName}
                </div>
                {/* ชือคนไข้ */}
                <div style={messageBodyItemInfo}>{row.Study?.PatientsName}</div>
                {/* ส่วนที่ตรวจ */}
                {row.Study?.StudyItems && row.Study.StudyItems > 0 ? (
                  <div style={messageBodyItemInfo}>
                    {row.Study?.StudyItems[0]?.ItemName}
                  </div>
                ) : (
                  <></>
                )}

                <div style={messageBodyItemInfo}>
                  {"ความเร่งด่วน: " + row.Study?.UrgentType?.UrgentTypeName}
                </div>
                <div style={messageBodyItemInfo}>
                  {CreateLabelInfo(
                    "วันที่เคส",
                    ConvertDateFromSQL(row.Study?.CreateDate)
                  )}
                </div>
                <div style={messageBodyItemInfo}>
                  {CreateLabelInfo(
                    "วันเวลาต้องการผล",
                    DateAddMinutes(
                      row.Study?.CreateDate,
                      row.Study?.UrgentType?.LimitInMinute
                    )
                  )}
                </div>
                {/* Reply Button Style */}
                {replyButtonStyle(row)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const messageBoxStyle = {
  border: "1px solid",
};

const messageBoxContainer = {
  // border: "1px solid #302f2f",
  padding: "10px",
  borderRadius: "10px",
  marginBottom: "5px",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "#1d1d3a",
};
const messageBodyHeader = {
  // flex: "1",
  display: "flex",
  justifyContent: "space-between",
  color: "#ffcc00",
};
const messageBodyBody = {
  flex: "1",
  display: "flex",
  justifyContent: "center",
  color: "#00ffcc",
};
const messageBodyItemInfo = {
  flex: "1",
  display: "flex",
  justifyContent: "start",
  color: "#828b8a",
};
const messageBodyHospital = {
  flex: "1",
  display: "flex",
  justifyContent: "start",
  color: "#828b8a",
};

const messageButton = { margin: "5px 5px 0 0px" };
const messageButtonContainer = {
  display: "flex",
  justifyContent: "space-between",
};

const spanLabel = {
  color: "#266fb9",
};
